import React from 'react';
import ReactDOM from 'react-dom';
import { translate } from "react-translate";
import { connect } from 'react-redux'
import _ from 'lodash';
import {
    Button,
    Container,
    Segment,
    Menu,
    Image,
    Dropdown,
    Header,
    List,
    Grid,
    Search,
    Advertisement,
    Icon,
    Divider,
    Table,
    Input,
    Item,
    Form,
    TextArea,
		Modal,
		Pagination
} from 'semantic-ui-react';

import './recherche.css';

import SearchIcon from '../../../assets/svg/searchIcon.svg';
import defautImage from '../../../assets/default/default.png';
import AddToList from '../../../assets/svg/add-to-list.svg';
import { Currencies } from '../../../constants/Currencies';

import API from '../../../services/api';

import ModalRechercheProduit from './ModalRechercheProduit';


const productPerPage = 10;

const mapStateToProps = state => ({
    app: state.app
});

class ConnectedRechercheComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
          isLoading: false,
					openAddToListModal: false,
					produits: [],
					selectedProduit: null,
					searchResults: [],
					currency : '€',
					activePage : 1,
					configFileLang: '',
					pkuidcountry : undefined
				}

				this.handleSearchChange = this.handleSearchChange.bind(this);
				this.handlePaginationChange = this.handlePaginationChange.bind(this);
				this.getGroupArticle = this.getGroupArticle.bind(this);
				this.resetComponent = this.resetComponent.bind(this);
				this.getDisplayedProducts = this.getDisplayedProducts.bind(this);
				this.getPaginationIndex = this.getPaginationIndex.bind(this);
    }

		componentWillMount() {
			var self = this;
			API.getUser(this.props.app.token).then((res) => {
				let tmpResponseCurrencies = Currencies.filter(currency => currency.value == res.data.currency);
				self.setState({
						currency: tmpResponseCurrencies.length > 0 ? tmpResponseCurrencies[0].text : '€',
						pkuidcountry : res.data.pkuid_country
					})
			});

			// Define lang here
			let configFileLang = 'fr_FR';
			self.setState({
				configFileLang
			})
		}

    resetComponent() {
			this.setState({
					isLoading: false,
					produits: [],
					value: '',
					isLoadingFilter: false,
					filterValue: '',
					filterResults: [],
					filterShowResults: this.state.filterResponse,
					activePage: 1,
			})
	}

		handleOpenModalForAddToList = (event, index) => {
			event.preventDefault();
			this.setState({
				openAddToListModal: true,
				selectedProduit: this.state.produits[index]

			})

		}

		handleCloseAddToListModal = () => {
			this.setState({
				openAddToListModal: false
			})
		}

		hanldeAddToList = (index, produit) => {
			// Add a produit with API
			this.setState({
				openAddToListModal: false
			})
		}


	handleSearchChange(e, { value }) {
		this.setState({
				isLoading: true, value
		})

		if(this.timeOut){
			clearTimeout(this.timeOut);
		}

		this.timeOut = setTimeout(() => {
				if (this.state.value.length < 1) this.resetComponent()
				this.getGroupArticle(value);
		}, 700)
	}

	getGroupArticle(value) {
		const { t } = this.props;
		var self = this;
		var groupArticleData = {
				q: this.state.value,
				lang: this.props.app.lang,
				sort : "DESC",
				rang: 200,
				c: this.state.pkuidcountry
		};
		API.getGroupArticle(this.props.app.token, groupArticleData).then((res) => {
				let searchResults = []
				if (res.data.code !== 200) {
						self.setState({
								isLoading: false,
								produits: []
						})

						return;
				}
				for (let article of res.data.groupArticles) {
						searchResults.push({
								"description": article.description, //TODO retrieve desc
								"title": article.name,
								"price": article.spmoy,
								"image": article.image !== 'upload/grouparticle/' ? API.resourceURL + '/' + article.image : defautImage,
								 "pkuidga": article.pkuidga,
								//"pkuida": article.pkuidarticle,
								"quantity" : 1,
								"link_picture": article.image !== 'upload/grouparticle/' ? API.resourceURL + '/' + article.image : defautImage,
								"link_article": article.provider_link_article,
								"link_tutorial": article.provider_link_tutorial,
						});
				}
				self.setState({
						isLoading: false,
						produits: searchResults,
				});
		});
	}

	handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

	getDisplayedProducts(){
		if(this.state.produits.length <= productPerPage) {
			return this.state.produits;
		}
		var beginIndex = (this.state.activePage - 1) * productPerPage;
		var endIndex = beginIndex + productPerPage;
		return _.slice(this.state.produits, beginIndex, endIndex);
	}

	getPaginationIndex(index){
		if(this.state.produits.length <= productPerPage) {
			return index;
		}

		var beginIndex = (this.state.activePage - 1) * productPerPage;

		return beginIndex + index;

	}

    render() {
        const { t } = this.props
				const { produits, openAddToListModal, selectedProduit, isLoading, searchResults, value, activePage } = this.state
        return (
            <div>
              <Grid stackable id="recherche">
                <Grid.Row columns={1} id="headerSection">
                  <Grid.Column width={6}>
                    <Segment basic>
                      <Item.Image size='mini' src={SearchIcon} id="imageSection" />
                      <Item.Content verticalAlign='middle'>
                        <Item.Header as='h3' id="titleSection">{t("Item1_title")}</Item.Header>
                      </Item.Content>
                    </Segment>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column verticalAlign='middle' width={16} textAlign="center" style={{ paddingRight: '2.5em', paddingLeft: '2.5em', }}>
                    <Item.Header as='h3' id="titleSubSection">{t("Item2_title")}</Item.Header>
										<Search id='SearchColumn' input={{ fluid: 'true' }}
										showNoResults={false}
											loading = {isLoading}
											onSearchChange={_.debounce(this.handleSearchChange, 500, { leading: true })}
											// results={produits}
											value={value}
											className={produits.length >= 1 ? 'search_bar' : ''}
											{...this.props}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column verticalAlign='middle' width={16} textAlign="left" style={{ paddingRight: '2.5em', paddingLeft: '2.5em', }}>
                    {produits.length > 0 ? (<Item.Header as='h4' style ={{ color: '#0964c1' }}textAlign="left">{produits.length + ' ' +  t("Item3_title")}</Item.Header>) : (<div/>) }
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Container textAlign='center' fluid id="recherche-container">
									{
										produits.length > productPerPage ? (
											<Pagination
												activePage={activePage}
												boundaryRange={3}
												onPageChange={this.handlePaginationChange}
												size='mini'
												pointing
												totalPages={ Math.ceil(produits.length / productPerPage)}
											/>
										) : (
											<div> </div>
										)
									}
                    <Segment style={{ borderRadius: '10px' }} raised>
                      <Grid stackable>
												{Object.entries(this.getDisplayedProducts()).map((key, index) =>{
													let produit = key[1]
													return (
		                        <Grid.Row columns={3} id="rechercheItem">
		                          <Grid.Column textAlign='center' verticalAlign='middle' computer={2}>
		                            <Image size='tiny' src={produit.image} />
		                          </Grid.Column>
		                          <Grid.Column textAlign='left' verticalAlign='middle' computer={8}>
		                            <Item.Header>{produit.title}</Item.Header>
		                            <Item.Meta>{produit.description}massif et contrecollés</Item.Meta>
		                            <Item.Extra>{produit.priceTitle}
                                  <span className="price">{produit.price}</span>
                                  <span className="priceCurrency">{this.state.currency}</span>
                                  <span className="unit">{produit.unit}/Unité</span>
                                </Item.Extra>
		                          </Grid.Column>
		                          <Grid.Column textAlign='center' verticalAlign='middle' computer={6}>
		                            <Button icon labelPosition='left'
																	onClick={(e) => this.handleOpenModalForAddToList(e, this.getPaginationIndex(index))}>
		                              <Icon><Image src={AddToList} /></Icon>
		                              {t("Btn1_text")}
		                            </Button>
		                          </Grid.Column>
		                        </Grid.Row>
													)}
											)}
                      </Grid>
                    </Segment>
                  </Container>
                </Grid.Row>
              </Grid>

							<ModalRechercheProduit
								isOpen={openAddToListModal}
								produit={this.state.selectedProduit}
								onAddToListCallback={this.hanldeAddToList}
								onCloseCallback={this.handleCloseAddToListModal}
								configFileLang = {this.state.configFileLang}
								currency = {this.state.currency}
							/>
            </div>
        );
    }
}
const RechercheComponent = connect(mapStateToProps)(ConnectedRechercheComponent)
export default translate("RechercheComponent")(RechercheComponent);



// WEBPACK FOOTER //
// ./src/components/Protected/Recherche/RechercheComponent.jsx